import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCommunity } from "../lib/api";
import { Trophy } from "lucide-react";

export default function ScoreboardWidget({ limit = 5 }) {
  const [scores, setScores] = useState([]);
  useEffect(() => { getCommunity("score").then(setScores).catch(() => {}); }, []);
  if (scores.length === 0) return null;
  return (
    <div data-testid="sports-scoreboard-widget" className="overflow-hidden rounded-lg border border-[var(--paper-border)] bg-white">
      <div className="flex items-center justify-between bg-[var(--navy)] px-4 py-2.5 text-white">
        <span className="font-ui flex items-center gap-2 text-sm font-bold uppercase tracking-wider"><Trophy size={16} className="text-[var(--gold)]" /> Coach's Scoreboard</span>
      </div>
      <div className="divide-y divide-slate-100">
        {scores.slice(0, limit).map((s) => (
          <Link key={s.id} to="/community" data-testid={`scoreboard-row-${s.id}`} className="block px-4 py-3 hover:bg-slate-50">
            <p className="font-ui text-[11px] font-bold uppercase tracking-wide text-[var(--gold)]">{s.sport}</p>
            <div className="mt-1 flex items-center justify-between gap-2">
              <span className="font-display truncate text-sm font-bold text-[var(--navy)]">{s.home_team}</span>
              <span className="font-display shrink-0 text-base font-extrabold text-[var(--navy)]">{s.home_score}</span>
            </div>
            <div className="mt-0.5 flex items-center justify-between gap-2">
              <span className="font-display truncate text-sm font-semibold text-slate-500">{s.away_team}</span>
              <span className="font-display shrink-0 text-base font-extrabold text-slate-400">{s.away_score}</span>
            </div>
            {s.standouts && <p className="font-serif-body mt-1 line-clamp-1 text-[11px] text-slate-500">★ {s.standouts}</p>}
          </Link>
        ))}
      </div>
      <Link to="/community" className="font-ui block border-t border-slate-100 px-4 py-2.5 text-center text-xs font-semibold uppercase tracking-wider text-[var(--navy)] hover:bg-slate-50">
        Full scoreboard & game reports →
      </Link>
    </div>
  );
}
